import axios from 'axios';

export default {
    cartToOrder(newOrderRequest) {        
        return axios.post('/api/orders/cart-to-order', newOrderRequest)
        .then(response => {
            if (response && response.data) return response.data;
        })
        
    },

    getOrderBySpecialRef(specialRef) {        
        return axios.get('/api/orders/get/special-ref', {params : {specialRef:specialRef}})
        .then(response => {
            if (response && response.data) return response.data;
        })
    },

    getOrderByPaymentRef(paymentRef) {        
        return axios.get('/api/orders/get/payment-ref', {params : {paymentRef:paymentRef}})
        .then(response => {
            if (response && response.data) return response.data;
        })
    },


    getOrders (page, pageSize, showDrafts,status,customerId,start,end,current,showUnsynchronisedOrders, channel) {
        return axios.get('/api/orders/list', { params: { page: page, pageSize: pageSize, showDrafts: showDrafts , status:status,customerId:customerId, start:start,end:end,current:current,showUnsynchronisedOrders:showUnsynchronisedOrders, channel:channel} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },

    getOrder (orderId) {
        return axios.get('/api/orders/order', { params: { orderId: orderId } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },

    getOrdersByCustomer (page, pageSize,supplierId, onlyDrafts,status,current,start,end, channel , itemTitle , orderRef) {
        return axios.get('/api/orders/customer/list', { params: { page: page, pageSize: pageSize,supplierId:supplierId, showDrafts: onlyDrafts, status : status,current:current, start:start,end:end, channel:channel , itemTitle:itemTitle ,orderRef:orderRef} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },

    getCustomerDeliveryAddresses () {
        return axios.get('/api/orders/customer/deliveryAdresses')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },

    getDeliveryModes () {
        return axios.get('/api/orders/deliveryModes')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },

    getOrdersCount(status){
        return axios.get('/api/orders/count/',{ params: { status:status} })
        .then(response => {
            if (response && response.data)  return response.data
        })
        .catch(error => {console.log(error);})
    },
}

